export enum QuestionType {
  MULTIPLE_CHOICE = "multiple-choice",
  FREE_TEXT = "free-text",
}

export enum QuestionDifficulty {
  EASY = "easy",
  MEDIUM = "medium",
  HARD = "hard",
}

export type PublishStatus = "all" | "some" | "none";
